
import { Component, Prop } from 'vue-property-decorator'
import CommonPopup from '../../../components/CommonPopup.vue';
import { LayoutDisplayItemOVO } from './vo/main.vo';
import { debounce, throttle } from "lodash-core";

@Component({
    components: {CommonPopup}
})
export default class MainImgViewerPop extends CommonPopup {
  @Prop()
  displayItems!: Array<LayoutDisplayItemOVO>;

  // 이미지 로드되면 layout 영역 height가 바뀜. 부모쪽 스와이퍼 update autoheight 발생 시켜야함
  onImageLoaded = debounce(this.onLayoutUpdated, 200);
  onLayoutUpdated() {
    this.$nextTick(() => {
      this.$emit("layout-update");
    });
  }
  moveLink (link: string) {
    if(link){
      this.$router.push(link);
      this.closePop();
    }
  }  
}
